import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/modules/shared.module';
import { HomeModule } from './pages/home/home.module';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatDialogModule } from '@angular/material/dialog';
import { AuthModule } from './features/auth/auth.module';
import { MessageComponent } from './shared/components/message/message.component';
import { CoreModule } from './core/modules/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { QuotationModule } from './features/quotation/quotation.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SendQuotationComponent } from './shared/components/send-quotation/send-quotation.component';
import { ComparePremiumComponent } from './shared/components/compare-premium/compare-premium.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { PolicyModule } from './features/policy/policy.module';
import { AdministrationModule } from './features/administration/administration.module';
import { DashboardModule } from './pages/dashboard/dashboard.module';
import { ErrorModule } from './pages/error/error.module';
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export const MY_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@NgModule({
  declarations: [
    AppComponent,
    MessageComponent,
    SendQuotationComponent,
    ComparePremiumComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    HomeModule,
    AuthModule,
    HttpClientModule,
    MatDialogModule,
    QuotationModule,
    MatCheckboxModule,
    FormsModule,
    MatChipsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatFormFieldModule,
    HttpClientModule,
    PolicyModule,
    CoreModule,
    ErrorModule,
    AdministrationModule,
    DashboardModule,
    TranslateModule.forRoot({     
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
    }),
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue:  MY_DATE_FORMATS }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
